export default "__VITE_ASSET__CTPdf0gj__"